import React from "react";

export const STATUS_STYLES = {
  // Projects
  lead: "bg-slate-100 text-slate-700 border-slate-200",
  quotation_sent: "bg-blue-50 text-blue-700 border-blue-200",
  confirmed: "bg-emerald-50 text-emerald-700 border-emerald-200",
  in_progress: "bg-indigo-50 text-indigo-700 border-indigo-200",
  submitted: "bg-purple-50 text-purple-700 border-purple-200",
  revision: "bg-amber-50 text-amber-700 border-amber-200",
  approved: "bg-emerald-50 text-emerald-700 border-emerald-200",
  on_hold: "bg-slate-100 text-slate-600 border-slate-200",
  cancelled: "bg-rose-50 text-rose-700 border-rose-200",
  completed: "bg-emerald-50 text-emerald-700 border-emerald-200",
  // Payment
  not_invoiced: "bg-slate-100 text-slate-700 border-slate-200",
  partially_invoiced: "bg-amber-50 text-amber-700 border-amber-200",
  fully_invoiced: "bg-blue-50 text-blue-700 border-blue-200",
  partially_paid: "bg-amber-50 text-amber-700 border-amber-200",
  fully_paid: "bg-emerald-50 text-emerald-700 border-emerald-200",
  paid: "bg-emerald-50 text-emerald-700 border-emerald-200",
  unpaid: "bg-slate-100 text-slate-700 border-slate-200",
  overdue: "bg-rose-50 text-rose-700 border-rose-200",
  // Invoice
  draft: "bg-slate-100 text-slate-700 border-slate-200",
  ready_to_send: "bg-blue-50 text-blue-700 border-blue-200",
  sent: "bg-indigo-50 text-indigo-700 border-indigo-200",
  invoice_pending: "bg-amber-50 text-amber-700 border-amber-200",
  invoiced: "bg-blue-50 text-blue-700 border-blue-200",
  not_due: "bg-slate-100 text-slate-600 border-slate-200",
};

export default function StatusBadge({ status, children }) {
  const cls = STATUS_STYLES[status] || "bg-slate-100 text-slate-700 border-slate-200";
  const label = children || (status || "").replace(/_/g, " ");
  return (
    <span className={`status-badge ${cls}`} data-testid={`status-${status}`}>
      {label}
    </span>
  );
}

export function formatCurrency(amount, currency = "USD") {
  const n = Number(amount || 0);
  return `${currency} ${n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function overdueTone(days) {
  if (days == null || days < -7) return "";
  if (days <= 0 && days >= -7) return "text-amber-600";
  if (days > 0 && days <= 15) return "text-orange-600 font-medium";
  if (days > 15) return "text-rose-600 font-semibold";
  return "";
}
